import { PAGE_ROUTES } from "lib/constants/page-routes";
import {
  PiHouseLight,
  PiShoppingCartSimpleLight,
  PiChartScatterLight,
  PiPowerLight,
  PiDatabaseLight,
  PiInvoiceLight,
  PiCalendarLight,
  PiUserLight,
  PiUsersLight,
  PiBuildingApartmentLight,
  PiPackageLight,
  PiChatCenteredLight,
} from "react-icons/pi";

const ICON_SIZE = "24px";
export const LOGOUT_SIDEBAR_MENU_ITEM = {
  id: 100,
  label: "Logout",
  icon: <PiPowerLight size={ICON_SIZE} strokeWidth={"2px"} />,
  href: PAGE_ROUTES.AUTHENTICATION.Signout,
} as GeneralItem;

export const PRACTITIONER_SIDEBAR_MENU_ITEMS = [
  {
    id: 0,
    label: "Dashboard",
    icon: <PiHouseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Dashboard,
  },
  {
    id: 1,
    label: "Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.AppointmentList,
  },
  {
    id: 2,
    label: "Subscriptions",
    icon: <PiShoppingCartSimpleLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Subscription,
    disabled: false,
  },
  {
    id: 4,
    label: "Payments",
    icon: <PiInvoiceLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Payments,
  },
  {
    id: 3,
    label: "Profile",
    icon: <PiUserLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Profile,
  },
] as GeneralItem[];

export const PATIENT_SIDEBAR_MENU_ITEMS = [
  {
    id: 0,
    label: "Dashboard",
    icon: <PiHouseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PATIENT.Dashboard,
  },
  {
    id: 2,
    label: "Book Appointment",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PATIENT.BookAppointment,
  },
  {
    id: 3,
    label: "Book Therapy Session",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PATIENT.BookTherapySession,
  },
  {
    id: 4,
    label: "Membership Package",
    icon: <PiPackageLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PATIENT.MembershipPackage,
  },
  {
    id: 5,
    label: "Consent Forms",
    icon: <PiInvoiceLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PATIENT.ConsentForm,
  },
  // {
  //   id: 6,
  //   label: "Notes",
  //   icon: <PiChatCenteredLight size={ICON_SIZE} strokeWidth={"2px"} />,
  //   href: PAGE_ROUTES.PATIENT.Notes,
  // },
  {
    id: 6,
    label: "Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PATIENT.Calender,
  },
  // {
  //   id: 3,
  //   label: "Profile",
  //   icon: <PiUserLight size={ICON_SIZE} strokeWidth={"2px"} />,
  //   href: PAGE_ROUTES.PATIENT.Profile,
  // },
] as GeneralItem[];

export const SUPER_ADMIN_SIDEBAR_MENU_ITEMS = [
  {
    id: 0,
    label: "Super Dashboard",
    icon: <PiHouseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    id: 1,
    label: "Configurations",
    icon: <PiDatabaseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Configurations,
  },
  {
    id: 2,
    label: "Practitioners Management",
    icon: <PiUsersLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.PractitionersManagement,
  },
  {
    id: 3,
    label: "Rooms Management",
    icon: <PiBuildingApartmentLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.RoomsManagement,
  },
  {
    id: 4,
    label: "Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Calendar,
  },
  {
    id: 5,
    label: "Payments",
    icon: <PiInvoiceLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Payments,
  },
  {
    id: 6,
    label: "Reports",
    icon: <PiChartScatterLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Reports,
  },
] as GeneralItem[];

export const ADMIN_SIDEBAR_MENU_ITEMS = [
  {
    id: 0,
    label: "Dashboard",
    icon: <PiHouseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    id: 1,
    label: "Configurations",
    icon: <PiDatabaseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Configurations,
  },
  {
    id: 2,
    label: "Practitioners Management",
    icon: <PiUsersLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.PractitionersManagement,
  },
  {
    id: 3,
    label: "Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Calendar,
  },
  {
    id: 4,
    label: "Payments",
    icon: <PiInvoiceLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Payments,
  },
  {
    id: 5,
    label: "Reports",
    icon: <PiChartScatterLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Reports,
  },
  {
    id: 6,
    label: "Invite Patient For Booking",
    icon: <PiUsersLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.BookAppointment,
  },
  {
    id: 7,
    label: "Patients Management",
    icon: <PiUsersLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.PatientsManagement,
  },
  {
    id: 8,
    label: "Therapy Sessions",
    icon: <PiInvoiceLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.TherapySessions,
  },
  {
    id: 9,
    label: "Patients Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.PatientsCalender,
  },
] as GeneralItem[];

export const RECEPTIONIST_SIDEBAR_MENU_ITEMS = [
  {
    id: 0,
    label: "Dashboard",
    icon: <PiHouseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Dashboard,
  },
  {
    id: 1,
    label: "Configurations",
    icon: <PiDatabaseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Configurations,
  },
  {
    id: 2,
    label: "Practitioners Management",
    icon: <PiUsersLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.PractitionersManagement,
  },
  {
    id: 3,
    label: "Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.Calendar,
  },
  {
    id: 4,
    label: "Invite Patient For Booking",
    icon: <PiUsersLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.BookAppointment,
  },
  {
    id: 5,
    label: "Therapy Sessions",
    icon: <PiInvoiceLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.TherapySessions,
  },
  {
    id: 6,
    label: "Patients Management",
    icon: <PiUsersLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.PatientsManagement,
  },
  {
    id: 7,
    label: "Patients Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.ADMIN.PatientsCalender,
  },
] as GeneralItem[];

// Function to generate practitioner menu items dynamically
export const getPractitionerMenuItems = (appState: any): GeneralItem[] => [
  {
    id: 0,
    label: "Dashboard",
    icon: <PiHouseLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Dashboard,
  },
  {
    id: 1,
    label: "Calender",
    icon: <PiCalendarLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.AppointmentList,
  },
  {
    id: 2,
    label: "Subscriptions",
    icon: <PiShoppingCartSimpleLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Subscription,
    disabled: appState?.status === "pending" ? true : false,
  },
  {
    id: 4,
    label: "Payments",
    icon: <PiInvoiceLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Payments,
  },
  {
    id: 3,
    label: "Profile",
    icon: <PiUserLight size={ICON_SIZE} strokeWidth={"2px"} />,
    href: PAGE_ROUTES.PRACTITIONER.Profile,
  },
] as GeneralItem[];
